import { Variants, easeOut } from "framer-motion";

export type AnimationType =
  | "fadeInUp"
  | "fadeInLeft"
  | "fadeInRight"
  | "staggerChildren";

export const getScrollAnimationVariants = (
  type: AnimationType = "fadeInUp"
): Variants => {
  const baseTransition = { duration: 0.8, ease: easeOut };

  switch (type) {
    case "fadeInUp":
      return {
        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: baseTransition,
        },
      };

    case "fadeInLeft":
      return {
        hidden: { opacity: 0, x: -40 },
        visible: {
          opacity: 1,
          x: 0,
          transition: baseTransition,
        },
      };

    case "fadeInRight":
      return {
        hidden: { opacity: 0, x: 40 },
        visible: {
          opacity: 1,
          x: 0,
          transition: baseTransition,
        },
      };

    case "staggerChildren":
      return {
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.12,
            delayChildren: 0.1,
          },
        },
      };

    default:
      return {
        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: baseTransition,
        },
      };
  }
};

export const defaultScrollViewportSettings = {
  once: true,
  amount: 0.15,
};

export const staggerItemVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: easeOut },
  },
};
